import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { GlobalErrorService } from '@services/global-error.service';
import { environment } from '@environments/environment';
import { Candidates } from '@interfaces/candidates.model';
import { ValidateProfilePayload, ValidateProfileResponse } from '../../vendor/add-candidate/add-candidate.model';
import { ProfileValidationService } from '@services/profile-validation.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpsCandidatesService {
  private baseUrl = environment.apiUrl;
  candidatesSignal: WritableSignal<any> = signal(null);

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
    private profileValidation: ProfileValidationService,
  ) {}

  getCandidates(page: number = 1, limit: number = 10, searchKey?: string, searchValue?: string): void {
    let params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));
    if (searchKey && searchValue) {
      params = params
        .set('search', 'true')
        .set(searchKey, searchValue);
    }
    this.http.get<any>(`${this.baseUrl}/ops/candidates`, { params }).subscribe({
      next: (data) => this.candidatesSignal.set(data),
      error: (error) => this.errorHandler.logError(error),
    });
  }

  /** Returns an Observable for a single page — used for bulk download fetching */
  fetchPage(page: number, limit: number, searchKey?: string, searchValue?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));
    if (searchKey && searchValue) {
      params = params
        .set('search', 'true')
        .set(searchKey, searchValue);
    }
    return this.http.get<any>(`${this.baseUrl}/ops/candidates`, { params });
  }

  validateProfileHistory(payload: ValidateProfilePayload): Observable<ValidateProfileResponse> {
    return this.profileValidation.validateProfile(payload);
  }
}